import { PhoneType } from "../../types";

export interface RegistrationModel {
  admin: AdminModel;
  password: string;
  acceptTermsAndConditions: boolean;
}

export interface AdminModel {
  gender: string; // TODO aim [SCD027ONBO-582]: replace w/ enum
  firstName: string;
  lastName: string;
  emailBusiness: string;
  mobile: PhoneType;
}

export enum RegistrationErrorStatus {
  "EMAIL_OTP_WRONG" = "EMAIL_OTP_WRONG",
}
